import { FC, useState, useEffect } from 'react';
import { Button, Grid, Input } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import DOMPurify from 'dompurify';

const { TextArea } = Input;

interface ChatMessagerProps {
  updateMessage: () => void;
  onSave: (data: { id: string; messages: { id?: string; sentBy?: string; message?: string; embedding?: string }[] }) => Promise<void>;
  caseId: string;
  disabled?: boolean;
}

export const ChatMessager: FC<ChatMessagerProps> = ({disabled = false, ...props}) => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const interval = setInterval(props.updateMessage, 60000);
    return () => clearInterval(interval);
  }, [props]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };
  const screen = Grid.useBreakpoint();
  const isMobile = screen.xs;
  const sendMessage = async () => {
    if (message === '') {
      return;
    }

    const input = {
      id: props.caseId,
      messages: [
        {
          sentBy: 'external',
          message: DOMPurify.sanitize(message)
        }
      ]
    };

    await props.onSave(input);

    setMessage('');
  };

  return (
    <div style={{width: isMobile ? '100%' : '75%', background: 'white', paddingBottom: '20px'}}>
      <div className='static' style={{background: 'transparent'}}>
        <TextArea
          style={{
            borderRadius: '8px',
            width: '100%',
            padding: '10px',
            outline: 'none',
            boxShadow: 'none',
            border: '1px solid #d9d9d9'
          }}
          autoSize={{ minRows: 1, maxRows: 4 }}
          onKeyDown={handleKeyDown}
          onChange={(e) => setMessage(e.target.value)}
          value={message}
          placeholder="Type a message..."
          disabled={disabled}
        />
        <Button
          style={{
            position: 'static',
            top: '50%',
            transform: 'translateY(-120%)',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            paddingLeft: 5,
            float: 'right'
          }}
          icon={<SendOutlined />}
          onClick={sendMessage}
          disabled={disabled || message.trim() === ''}
        />
      </div>
    </div>
  );
};
